import { SB } from '@play-co/replicant';

// Score data for frenzy competition
export default SB.object({
  bucketID: SB.string().default('control'), // control or minigame_only or competition_only
  claimed: SB.boolean().default(true), // Claimed by default
});
